<template>
  <div class="n-modal__inner">
    <div class="n-modal__cont" v-if="!products.length">
        <div class="n-modal__title">{{ clientSettings.name }}</div>
        <!-- <div class="n-modal__place"><i class="icon-place"></i> 856 Esta Underpass</div> -->
        <div class="n-modal__sub-title">{{ t('message["Order is empty"]', 'Order is empty') }}</div>
    </div>
    
    <div v-else>
      <div class="n-modal__cont">
        <div class="n-modal__title">{{ clientSettings.name }}</div>
        <!-- <div class="n-modal__place"><i class="icon-place"></i> 856 Esta Underpass</div> -->
        
        <div class="table-responsive">
          <table class="table-total">
            <tbody>
              <tr v-for="product in products" :key="product.id">
                <td class="table-total__name">{{ product.name[selectedLanguage.key] }}</td>
                <td>{{ product.count }}</td>
                <td class="table-total__price">{{ product.price * product.count }} AED</td>
                <td width="20">
                  <div class="confirm_button">
                    <button @click="removeItemFromCart(product)" class="table-total__btn-clear">
                      <i class="icon-clear"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="separator">
        <div class="separator__inner"></div>
      </div>
      
      <div class="n-modal__cont">
        <div class="n-modal__sub-title">{{ t('message["Add your note"]', 'Add your note') }}</div>
        
        <div class="n-modal__row" v-if="!isTable">
          <label class="n-modal__label" for="phone-input">{{ t('message["Phone"]', 'Phone') }}:</label>
          <input
            class="form-control"
            v-model="form.phone"
            v-mask="'+###########'"
            @keyup="updatePhoneValidation"
            :class="{ 'error': phoneError }"
            name="phone"
            :placeholder="getMessage('Phone number')">
        </div>
        <!-- Address input-->
        <div class="mt-3" v-if="!isTable">
          <label class="n-modal__label" for="example-textarea">{{ t('message["Address"]', 'Address') }}:</label>
          <textarea v-model="form.address" @keyup="updateAddressValidation" :class="{ 'error': addressError }"
            name="address" class="form-control" rows="3" :placeholder="getMessage('Write your address')" required=""></textarea>
        </div>

        <!-- Add note input-->
        <div class="mt-3">
          <label class="n-modal__label" for="example-textarea">{{ t('message["Add a Note"]', 'Add a Note') }}:</label>
          <textarea v-model="form.note" name="note" class="form-control" rows="3"
            :placeholder="getMessage('Write some note..')"></textarea>
        </div>
      </div>
      
      <div class="separator">
        <div class="separator__inner"></div>
      </div>
      
      <div class="n-modal__cont">
        <div class="total">
          <div class="total__name col-auto">{{ t('message["Total"]', 'Total') }}</div>
          <div class="total__price col-auto ml-auto">{{ totalCartPrice }} AED</div>
        </div>
      </div>
      
      <button v-if="!submittedOrder" @click="submit()" class="n-modal__submit">
        {{ t('message["Order"]', 'Place order') }}
      </button>
      <button v-if="submittedOrder" @click="$emit('update-order', form)" class="n-modal__submit">
        <i class="mdi mdi-cart-plus mr-1"></i>
        {{ t('message["Update Order"]', 'Update Order') }}
      </button>
      <input type="hidden" name="table_id" value="5">
    </div> <!-- end card-body-->

  </div>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import language from '../mixins/translate'
  import {
    mapState,
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    mixins: [language],
    directives: { mask },
    computed: {
      ...mapState('settings', ['selectedLanguage', 'isTable', 'clientSettings']),
      ...mapGetters('cart', ['totalCartPrice']),
      ...mapState('cart', ['cartProducts', 'submittedOrder']),
      products() {
        return Object.keys(this.cartProducts).map(key => this.cartProducts[key])
      }
    },
    data() {
      return {
        form: {
          phone: '',
          notes: '',
          address: ''
        },
        fake: '',
        addressError: false,
        phoneError: false
      }
    },
    methods: {
      ...mapActions('cart', ['removeCartItem']),
      removeItemFromCart(product) {
        this.removeCartItem(product)
      },
      updateAddressValidation() {
        if (!this.form.address) {
          this.addressError = true
        } else {
          this.addressError = false
        }
      },
      updatePhoneValidation() {
        if (this.form.phone.length < 12) {
          this.phoneError = true
        } else {
          this.phoneError = false
        }
      },
      getMessage(message) {
        return this.t(`message["${message}"]`, message)
      },
      submit() {
        if (this.isTable) {
          this.$emit('submit-order', this.form)
        }
        if (!this.form.address) {
          this.addressError = true
        }
        if (!this.form.address || !this.form.phone) {
          return;
        }
        this.$emit('submit-order', {
          ...this.form
        })
      }
    }
  }
</script>

<style>
  input.form-control.error,
  textarea.form-control.error {
    border-color: red
  }

  .card-wrapper {
    padding: 2rem
  }

  @media only screen and (max-width: 600px) {
    .card-wrapper {
      padding: 10px
    }
  }

  .dropdown.open {
    outline: none
  }
</style>
